import gql from "graphql-tag";

export const updateArticleMatchesPageMutation = gql`
  mutation updateArticleMatchesPage($page: Number!) {
    updateArticleMatchesPage(page: $page) @client
  }
`;

export const updateArticleMatchesPage = (_, { page }, { cache }) => {
  cache.writeData({
    data: {
      articleMatchesPage: page,
    },
  });

  return null;
};



// WEBPACK FOOTER //
// ./src/mutations/updateArticleMatchesPageMutation.js